var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messangerId)?_c('div',{style:({display: _vm.display}),attrs:{"data-messanger":"facebook"}},[_c('div',{attrs:{"id":"fb-root"}}),_c('div',{staticClass:"fb-customerchat",attrs:{"id":"fb-customer-chat"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }